module.exports = __webpack_public_path__ + "static/media/client-advocate-il.992c0f5a.png";